import React, { useState, useRef, useEffect } from "react";
import { ChevronDownIcon } from "../icons";
import { CLIENT_ADMIN_PAGE, isClientAdminPage } from "../../config/constants";
import { Archive, UploadCloud, Building2, History } from "lucide-react";

const MASTER_ADDRESS_PAGE = "master-address";

const MENU = [
  { page: CLIENT_ADMIN_PAGE.IMPORT, label: "Import inventory", icon: Archive },
  { page: CLIENT_ADMIN_PAGE.INVOICE, label: "Upload invoice", icon: UploadCloud },
  { page: MASTER_ADDRESS_PAGE, label: "Master Address", icon: Building2 },
  { page: CLIENT_ADMIN_PAGE.ACTIVITY, label: "Activity log", icon: History },
];

/**
 * Top-nav dropdown for Client Administration (replaces separate landing cards).
 */
const ClientAdministrationNavGroup = ({ currentPage, onNavigate }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const go = (page) => (e) => {
    e.preventDefault();
    onNavigate(page);
    setOpen(false);
  };

  const active = isClientAdminPage(currentPage) || currentPage === MASTER_ADDRESS_PAGE;

  return (
    <div className="relative" ref={wrapRef} style={{ zIndex: open ? 150 : "auto" }}>
      <button
        type="button"
        className={`nav-item ${active ? "active" : ""}`}
        aria-expanded={open}
        aria-haspopup="menu"
        onClick={(e) => {
          e.preventDefault();
          setOpen((v) => !v);
        }}
      >
        Client Administration
        <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>

{open && (
        <div
          className="absolute left-0 top-full mt-2 min-w-[260px] max-w-[min(100vw-2rem,280px)] rounded-xl border border-gray-200/90 bg-white shadow-xl z-[120] text-left overflow-hidden divide-y divide-gray-100"
          role="menu"
        >
          {MENU.map(({ page, label, icon: Icon }) => (
  <button
    key={page}
    type="button"
    role="menuitem"
    className={`w-full text-left flex items-center gap-3 px-4 py-3.5 text-sm font-medium transition-colors ${
      currentPage === page ? "bg-red-50 text-red-900" : "text-gray-800 hover:bg-gray-50"
    }`}
    onClick={go(page)}
  >
    <span className="mt-0.5 shrink-0 text-gray-400">
      <Icon className="w-5 h-5" strokeWidth={2} />
    </span>
    <span className="leading-snug pt-0.5">{label}</span>
  </button>
))}
        </div>
      )}
    </div>
  );
};

export default ClientAdministrationNavGroup;